
<div style="margin:145px">
</div>

<div class="container" style="margin-bottom:0px">
  <div class="row">
    <div class="col-sm-6" style="padding-left: 35px;">
      <div class="image-container"  >
        <img style="height:340px"  src="./../../assets/images/Job_Profile_landing.jpg"  name="submit" alt="submit"  />
      
    </div>
    <p> Machine Learning and AI enabled algorithm to match <br> <b> jobs to  market surveys </b> </p>  
    <div ><button (click)="new_showComponent('JobProfileMatching','pro')" >Open -></button></div>
    
    </div>
  
    <div class="col-sm-6" style="padding-left: 45px;">
      
      <div class="image-container"  >
      <img style="height:340px" src="./../../assets/images/aq-jobprofile-inside.jpg"  name="submit" alt="submit"   />
    </div>
      <p>Machine Learning and AI enabled algorithm to match <br> <b> new jobs to existing jobs </b> 
       </p>
      
       <div  > 
        <button (click)="new_showComponent('aq-JobProfileMatching','aq')"  >Open -></button>
      </div>
  </div>
  </div>
  </div>
  <div [style.display]="ShowLoader">
    <div class="loading" >
     <span > Please allow a min while the application loads </span>
    
    </div>
    <div class="background-image"></div>
   
    <div id="loader">
      
  
    </div>
   
    
  </div>